export default "__VITE_ASSET__CIlGYetg__"